// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-page .custom-page-options[data-v-a983e994]{margin:5px 0 0 20px;min-width:320px;width:-moz-fit-content;width:fit-content}.set-landing-leadin[data-v-a983e994]{padding-bottom:10px}", ""]);
// Exports
module.exports = exports;
